import {Flex, Title, Button, PriorityIcon} from '@priority-software/priority-style-react';
import React from 'react';
import styles from './styles.module.scss';
import emptyState from '../../../../images/emptyStateAnalytics.svg';
import noMatch from '../../../../images/noReports.svg';
import texts from '../../texts';
import {createDataTestId} from '../../../../utils/dataTestId';
import cx from 'classnames';
interface Props {
    onAddReport: () => void;
    text: string;
    componentClasses?: string;
}

export type NoMatchProps = {
    componentClasses?: string;
    text: string;
};

export const NoReportsEmptyState = ({onAddReport, text, componentClasses}: Props) => (
    <Flex
        direction="column"
        componentClasses={cx(styles.emptyStateContainer, componentClasses)}
        justifyContent="center"
        {...createDataTestId('reports-empty-state', true)}
    >
        <img src={emptyState} />
        <Flex
            componentClasses={styles.emptyStateTextWrapper}
            direction="column"
            justifyContent="center"
        >
            <Title textColor="secondary-500" skin="h4" text={text} />
            <Button onClick={onAddReport} prefixIcon={PriorityIcon.add}>
                {texts.newReportBtn}
            </Button>
        </Flex>
    </Flex>
);

export const NoMatchEmptyState = ({componentClasses, text}: NoMatchProps) => (
    <Flex
        direction="column"
        componentClasses={cx(styles.emptyStateContainer, componentClasses)}
        justifyContent="center"
    >
        <img src={noMatch} />
        <div style={{textAlign: 'center'}}>
            <Title skin="h4" text={text} textColor="secondary-500" />
        </div>
    </Flex>
);
